import styled from 'styled-components';

export const Wrapper = styled.div`
  align-items: center;
  background: #e2eaee;
  display: flex;
  height: 40px;
  justify-content: center;
  position: fixed;
  right: 0;
  top: 92px;
  width: 100vw;
  z-index: 3000;
`;
